
import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import Logo from "../Logo/logo31.png";
import "./Navbar.css";

export default function Navbar({ theme, setTheme }) {
  const [open, setOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  const navbarRef = useRef(null);
  const navigate = useNavigate();

  const closeMenus = () => {
    setOpen(false);
    setOpenDropdown(null);
  };

  const toggleDropdown = (name) => {
    setOpenDropdown((current) => (current === name ? null : name));
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        closeMenus();
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        closeMenus();
      }
    };

    document.addEventListener("pointerdown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("hashchange", closeMenus);

    return () => window.removeEventListener("hashchange", closeMenus);
  }, []);

  return (
    <header
      ref={navbarRef}
      className={`navbar ${scrolled ? "scrolled" : ""}`}
    >
      <div className="nav-inner">
        {/* BRAND */}
        <button
          type="button"
          className="brand"
          onClick={() => {
            closeMenus();
            navigate("/");
          }}
        >
          <img
            className="logo"
            src={Logo}
            alt="Beth Branson Memorial Match logo"
          />

          <span className="brand-text">
            The Beth Branson Memorial Match
          </span>
        </button>

        {/* NAVIGATION */}
        <nav
          id="main-navigation"
          className={`links ${open ? "open" : ""}`}
          aria-label="Main navigation"
        >
          <NavLink to="/" end onClick={closeMenus}>
            Home
          </NavLink>

          {/* DONATE DROPDOWN */}
          <div
            className={`nav-dropdown ${
              openDropdown === "donate" ? "open" : ""
            }`}
          >
            <button
              type="button"
              className="nav-dropdown-toggle"
              aria-expanded={openDropdown === "donate"}
              onClick={() => toggleDropdown("donate")}
            >
              Donate

              <svg
                className="chevron-icon"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>

            <div className="nav-dropdown-menu">
              <NavLink to="/stgilesdonate" onClick={closeMenus}>
                St Giles
              </NavLink>

              <NavLink to="/woodenspoondonate" onClick={closeMenus}>
                Wooden Spoon
              </NavLink>
            </div>
          </div>

          {/* GALLERY DROPDOWN */}
          <div
            className={`nav-dropdown ${
              openDropdown === "gallery" ? "open" : ""
            }`}
          >
            <button
              type="button"
              className="nav-dropdown-toggle"
              aria-expanded={openDropdown === "gallery"}
              onClick={() => toggleDropdown("gallery")}
            >
              Gallery

              <svg
                className="chevron-icon"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>

            <div className="nav-dropdown-menu">
              <NavLink to="/upload-images" onClick={closeMenus}>
                Upload Photos
              </NavLink>

              <NavLink to="/gallery" onClick={closeMenus}>
                View Gallery
              </NavLink>
            </div>
          </div>

          <NavLink to="/amount-raised" onClick={closeMenus}>
            Amount Raised
          </NavLink>

          <NavLink to="/Our-Story" onClick={closeMenus}>
            Our Story
          </NavLink>

          <NavLink to="/match-info" onClick={closeMenus}>
            Match Info
          </NavLink>

          <NavLink to="/media" onClick={closeMenus}>
            Media
          </NavLink>

          <NavLink to="/allauctions" onClick={closeMenus}>
            Auctions
          </NavLink>
        </nav>

        {/* THEME TOGGLE AND HAMBURGER */}
        <div className="nav-actions">
          <button
            type="button"
            className="theme-toggle"
            aria-label="Toggle theme"
            onClick={() =>
              setTheme(theme === "dark" ? "light" : "dark")
            }
          >
            {theme === "dark" ? "☀️" : "🌙"}
          </button>

          <button
            type="button"
            className={`hamburger ${open ? "open" : ""}`}
            aria-label="Toggle navigation"
            aria-controls="main-navigation"
            aria-expanded={open}
            onClick={() => {
              setOpen((current) => !current);
              setOpenDropdown(null);
            }}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </header>
  );
}